import React from "react";
import vehiclecount from "../../assets/vehiclecount.svg";
import Vehfuel from "../../assets/Veh&fuel.svg";
import longtruck from "../../assets/images/long-truck-icon.svg";
import gasstation from "../../assets/images/gasstationfleet.svg";
import ContentRight from "./ContentRight";
import ContentLeft from "./ContentLeft";

const Vehiclefuelcard = ({ totalvehiclecount, feKmPlHr, avgfuelconsumed }) => {
  // Validation to check if totalvehiclecount is valid
  const isValidData = totalvehiclecount != null && !isNaN(totalvehiclecount);

  return (
    <div className="bg-white mb-2 mr-[0.5rem]" style={{}}>
      <div className="bg-white rounded-md  min-w-full flex flex-col w-full sm:w-[200px] xl:w-[240px] 2xl:w-[350px] min-h-[180px] h-full">
        <p className="text-sm mt-3  mb-5  bg-[#056DB3] p-1 text-center text-white sm:w-full">
          Vehicle & Fuel
        </p>

        {!isValidData ? (
          <div className="text-center text-red-500 font-bold p-4">
            Error: Data not found
          </div>
        ) : (
          <>
            <ContentRight paricon={longtruck} parValue={totalvehiclecount} />
            <div className="flex">

              <div className="flex items-center justify-center w-full gap-2 lg:gap-0">
                <div class="hidden md:block w-[2px] h-32 bg-[#84afcd] ml-20"></div>
              </div>
              <p className="ml-2 text-xs"> Vehicle Count</p>

            </div>

            <ContentLeft parValue={avgfuelconsumed} paricon={gasstation} />
            <p className="ml-2 text-xs">                   FE KMPL & Ltr/Hr
            </p>

          </>
        )}
      </div>
    </div >
  );
};

export default Vehiclefuelcard;